import { differenceInWeeks, format, isToday } from 'date-fns';
import { frCA, enCA } from 'date-fns/locale';

export const formatMessageDate = (messageDate: string, locale?: 'en' | 'fr') => {
    const date = new Date(messageDate);
    const diffInWeeks = differenceInWeeks(new Date(), date);
    if (isToday(date)) {
        return format(date, 'p', { locale: locale === 'en' ? enCA : frCA });
    }
    if (diffInWeeks < 1) {
        return format(date, 'MMM d', { locale: locale === 'en' ? enCA : frCA });
    }

    return format(date, 'yyyy/MM/dd', { locale: locale === 'en' ? enCA : frCA });
};

export const formatDateCustom=(date)=> {
    const d = new Date(date);
    const month = String(d.getMonth() + 1).padStart(2, '0'); // getMonth() is zero-based
    const day = String(d.getDate()).padStart(2, '0');
    const year = d.getFullYear();
    const dateFormatted = `${month}/${day}/${year}`;
    
    if(dateFormatted=='12/31/1969') return null;

    return dateFormatted;
}